require('leaflet');
require('leaflet.vectorgrid');

var tile_url = 'https://transitoseguro.cobli.co';

var $toggle = document.querySelector('.maioAmarelo-legenda-titulo');
var $select = document.querySelector('.maioAmarelo-legenda-body-controle-opcoes');


var map = L.map('map', { zoomControl: false, minZoom: 3, maxZoom: 16 }).setView([-19.1940082,-56.448897], 5);

L.control.zoom({
    position:'bottomright'
}).addTo(map);

L.tileLayer('https://api.mapbox.com/styles/v1/coblitech/cjh24ghi90wmu2rp7c4v9j0l0/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiY29ibGl0ZWNoIiwiYSI6ImNqaDgwaXFmNDAybTAydnJza3ZwZHhzdGkifQ.9ryUvsUNkOb8mJ0dRsR6BA', {
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    maxZoom: 16,
}).addTo(map);

var currentLayer = L.vectorGrid.protobuf(tile_url + '/2019/tiles/all/{z}/{x}/{y}.pbf', {maxZoom: 16, vectorTileLayerStyles: {
    'events': function(properties) {
        return {
            fill: true,
            fillOpacity: .7,
            fillColor: properties.fill,
            weight: 0
        };
    }
}});
currentLayer.addTo(map);

var ua = navigator.userAgent.toLowerCase();
var is_safari = (ua.indexOf('safari') != -1) && (ua.indexOf('chrome') == -1);

var scroll = function (up) {
    var animateScroll = function (element, to, duration) {
        var difference = to - element.scrollTop ;
        var perTick = Math.abs(difference / duration * 10);
        if (duration <= 0) return;

        setTimeout(function () {
            element.scrollTop = up ? element.scrollTop - perTick : element.scrollTop + perTick;
            if (element.scrollTop === to) return;
            animateScroll(element, to, duration - 10);
        }, 10);
    };

    if (up) {
        var topPos = 0;
    } else {
        var $opcoes = document.querySelector('.maioAmarelo-legenda-titulo');
        var topPos = $opcoes.offsetTop - 200;
    }
    animateScroll(is_safari ? document.body : document.documentElement, topPos, 500);
};


$toggle.addEventListener('click', function (e) {
    scroll(false);
});

$select.addEventListener('change', function (e) {
    map.removeLayer(currentLayer);

    target = e.target;
    selectedEvent = target.options[target.selectedIndex].value;

    currentLayer = L.vectorGrid.protobuf(tile_url + '/2019/tiles/' + selectedEvent + '/{z}/{x}/{y}.pbf', {maxZoom: 16, vectorTileLayerStyles: {
        'events': function(properties) {
            return {
                fill: true,
                fillOpacity: .7,
                fillColor: properties.fill,
                weight: 0
            };
        }
    }});
    currentLayer.addTo(map);

    if (window.innerWidth <= 768) {
        scroll(true);
    }
});
